
import { Component, Prop, Vue } from "vue-property-decorator";
import { LiveEventsConfigInterface } from "./liveevents.types";
import { INASALiveEvent, INASALiveEvents } from "../../store-services/staticdata.types";

type StateInterface = "unknown" | "live" | "next" | "upcoming";

@Component
export default class LiveEventsComponent extends Vue {
  @Prop() config!: LiveEventsConfigInterface;
  thumbnail: string = "";
  timestamp: number = Date.now();
  timestampInterval: number = NaN;
  videoPlaybackError: boolean = false;

  mounted() {
    this.$store.dispatch("staticdata/updateLiveEvents");

    this.timestampInterval = setInterval(() => {
      this.timestamp = Date.now();

      if ((this.timestamp - this.events.timestamp.getTime()) > 15 * 60000) {
        this.$store.dispatch("staticdata/updateLiveEvents");
      }
    }, 30000)
  }
  unmounted() {
    if (this.timestampInterval) clearInterval(this.timestampInterval);
  }

  get events(): INASALiveEvents {
    return this.$store.getters["staticdata/getLiveEvents"];
  }
  get eventsBackendStatus() {
    return this.events.status
  }

  get nextEvent(): INASALiveEvent | undefined {
    return this.events.content?.data[0]
  }
  get nextEventState(): StateInterface {
    if (this.nextEvent) {
      const startTime = (new Date(this.nextEvent.startTime)).getTime();
      const endTime = (new Date(this.nextEvent.endTime)).getTime();
      if (((startTime - 2 * 60000) < this.timestamp) && (this.timestamp < endTime)) {
        return "live"
      } else if ((startTime - this.timestamp) < 3600000) {
        return "upcoming"
      } else {
        return "next"
      }
    } else {
      return "unknown"
    }
  }

  formatDates(start: string, end: string) {
    const ds = new Date(start);
    const de = new Date(end);

    const dateTime_fmt = Intl.DateTimeFormat('en-US', {month: "short", day: "numeric", hour: "numeric", hour12: true, minute: "2-digit"})
    const time_fmt = Intl.DateTimeFormat('en-US', {timeStyle: "short"})

    return `${dateTime_fmt.format(ds)} - ${
      ds.getDay() === de.getDay() ? time_fmt.format(de) : dateTime_fmt.format(de)
    }`
  }

  replaceTimes(text: string) {
    let d = new Date()
    const time_fmt = new Intl.DateTimeFormat("en-US", {timeStyle: "short"})
    const day_fmt = new Intl.DateTimeFormat("en-US", {day: "numeric", month: "long"})
    const tstext_fmt = (date: Date) => `${time_fmt.format(date)} on ${day_fmt.format(date)}`
    return text.replaceAll(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/g, (match) => day_fmt.format(d) == day_fmt.format(new Date(match)) ? time_fmt.format(new Date(match)) : tstext_fmt(new Date(match)))
  }
}
